module.exports = __webpack_public_path__ + "img/20191227155656360截图20191227110717451.d7bc4c32.jpg";